import { ModelBase } from 'store/model-base';

export class CmsCompatibilityCheck extends ModelBase {
    public static storeName: string = 'cmsCompatibilityCheck';

    public deviceCheck: DeviceDetails;
    public deviceCompatible: CompatibilityConfirmed;
    public compatibilityBase: CompatibilityBase;
    public compatibilityBreadcrumbs: CompatibilityBreadcrumb[];
    public instruction: InstructionDetails;
    public simInstructionModal: MultiImageModalData;
    public deviceImei: CompatibilityEnterImei;
    public success: ActivationSuccess;
    public incompatible: IncompatibilityData;
    public psimCompatibility: psimCompatibility;
    public transferService: TransferServiceConfirmed;
    public byodActivateSim: ByodActivationActivateTransferSim;
    public transferServicePixel: TransferServiceConfirmedPixel;
    public transferServiceGalaxy: TransferServiceConfirmedGalaxy;
    public transferServicePixelGalaxy: TransferServiceConfirmedInstructionsPixelGalaxy;
    public footerText: TransferServiceFooter;
    public fccSimSwap: FccSimSwap;
    public otpError: ActivationOtpError;
    public tooManyAttemptsError: ActivationOtpError;
}
